export class SetJobTypes {
    static readonly type = '[JobType] set';
    constructor(public data: any[]) { }
}
